ReadMore = window.ReadMore ?= {}

_readMore = (pitch, readMoreSection, targetHeight) ->
  pitch.css 'max-height', "#{targetHeight}px"
  readMoreSection.find('.read-less').css 'display', 'inline'
  readMoreSection.find('.read-more').css 'display', 'none'
  readMoreSection.find('.gradient-finish').css 'display', 'none'

_readLess = (pitch, readMoreSection, targetHeight) ->
  pitch.css 'max-height', "#{targetHeight}px"
  readMoreSection.find('.read-less').css 'display', 'none'
  readMoreSection.find('.read-more').css 'display', 'inline'
  readMoreSection.find('.gradient-finish').css 'display', 'inline'

ReadMore.init = (payload, done) ->
  $ ->
    $pitch = $('.pitch-container')
    moreHeight = $('#deal-info').height() + 100
    lessHeight = $('.purchase-cluster-bottom').height() + 80
    $pitch.css 'max-height', "#{lessHeight}px"
    readMore = I18n.translate('.modules.goods_v2.read_more')
    readLess = I18n.translate('.modules.goods_v2.read_less')

    readMoreHtml = "<div id='read-more-section' >
        <div class='gradient-finish'></div>
        <div class='read-more-container'>
          <span class='read-more' data-height='#{moreHeight}' data-bhw='ReadMore'> #{ readMore } <span class='icon-arrow-down'></span></span>
          <span class='read-less' data-height='#{lessHeight}' data-bhw='ReadLess'> #{ readLess } <span class='icon-arrow-up'></span></span>
        </div>
      </div>"

    $readMoreSection = $(readMoreHtml).insertAfter($pitch)
    $('.read-more').click -> _readMore $pitch, $readMoreSection, $(this).data('height')
    $('.read-less').click -> _readLess $pitch, $readMoreSection, $(this).data('height')
    done()


module.exports = ReadMore
